import { PreguntasTipoEnum } from "@shared/enums";
import { DatosPreguntaImportador } from "../DatosPreguntaImportador";
import { PREGUNTA_PADRE } from "../constantesImportador";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaMatrixMultipleImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.MATRIX_MULTIPLE;
    }

    public testear(datos: DatosPreguntaImportador[], esUltima: boolean = false): boolean {
        const pasoTest = super.testear(datos, esUltima);
        const preguntaPadre = datos[PREGUNTA_PADRE];
        if (!preguntaPadre.random && preguntaPadre.tipoOpcion !== "R") {
            this.advertencias.push(
                `La pregunta ${datos[PREGUNTA_PADRE].idPregunta} no esta marcada como Random`
            );
        }
        return pasoTest;
    }
}
